<template>
  <Modal
    open
    @close="handleCancelButtonClick"
    size="small"
    :hideScrollbar="true"
    :roundedOnMobile="true"
    class="[&_.modal-position]:!px-6"
  >
    <div
      class="m-2 flex flex-col items-center bg-white text-center sm:rounded-lg"
    >
      <div class="flex flex-col items-center justify-center">
        <h2
          class="h-auto px-0 text-left text-xl font-medium text-gray-900 sm:text-xl"
        >
          {{ __('This action will permanently delete the pipeline.') }}
        </h2>

        <p class="mt-2 w-full text-left text-base text-gray-800">
          {{ __('Are you sure you want to proceed?') }}
        </p>
      </div>
      <div class="mt-8 flex w-full flex-row items-center justify-end gap-2">
        <Button
          class="flex items-center justify-center gap-1.5"
          type="button"
          variant="ghost-no-padding"
          tabindex="-1"
          style="width: 8rem !important"
          @click="handleCancelButtonClick"
        >
          <span>{{ __('Cancel') }}</span>
        </Button>
        <Button
          class="flex items-center justify-center gap-1.5"
          type="button"
          tabindex="-1"
          style="width: 8rem !important"
          @click="$emit('delete', pipelineId)"
        >
          <span>{{ __('Yes, Delete It') }}</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
  import { Button } from '@/components/block/button';
  import Modal from '../../../../components/block/modal/modal.vue';

  import { __ } from '@/helpers';
  const props = defineProps({
    pipelineId: {
      type: Number,
      required: false
    }
  });
  const emits = defineEmits(['cancel']);

  function handleCancelButtonClick() {
    emits('cancel');
  }
</script>
